import { createApp } from 'vue'
import axios from 'axios'
import Personnummer from 'personnummer';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-register-company').forEach((el) => {
        const app = createApp({
            data() {
                return {
                    fieldOrgNumber: '',
                    isSwedishOrgNumber: true,
                    fieldCompanyName: '',
                    fieldBillingAddress1: '',
                    fieldBillingAddress2: '',
                    fieldBillingZipCode: '',
                    fieldBillingCity: '',
                    fieldBillingCountry: '',
                    fieldBillingEmail: '',
                    fieldVisitingAddress1: '',
                    fieldVisitingAddress2: '',
                    fieldVisitingZipCode: '',
                    fieldVisitingCity: '',
                    fieldVisitingCountry: '',
                    fieldEmail: '',
                    fieldFirstName: '',
                    fieldLastName: '',
                    fieldPhone: '',
                    formError: false,
                    formLoading: false,
                    result: false,
                    orgDropdownOpen: false,
                    init: false,
                    checkedCompany: false,
                    companyExists: false,
                    step: 1,
                    hasAccount: null,
                    fieldPersonalNumber: '',
                    bankIdPersonalNumber: '',
                    restBase: liGlobal.restBase,
                    authenticatedUser: false,
                    templateDirectory: liGlobal.templateDirectory,
                    qrCode: null,
                    bankIdInterval: null,
                    fieldReference: '',
                    registeredExisting: null,
                    countries: [],
                    selectedBillingCountry: 1,
                    selectedVisitingCountry: 1,
                    billingCountriesDropdownOpen: false,
                    billingCountriesFocusedIndex: -1,
                    billingCountriesSearch: '',
                    visitingCountriesDropdownOpen: false,
                    visitingCountriesFocusedIndex: -1,
                    visitingCountriesSearch: '',
                }
            },
            components: {
            },
            async created() {
                const countriesResponse = await this.$http.get(this.restBase + '/get-countries');
                this.countries = countriesResponse.data.Countries.sort((a, b) => a.CountryName.localeCompare(b.CountryName, 'sv-SE'));

                this.init = true;
            },
            mounted() {
                document.addEventListener('click', this.handleClickOutside);
            },
            beforeUnmount() {
                document.removeEventListener('click', this.handleClickOutside);
                document.removeEventListener('keydown', this.handleBillingCountriesKeydown);
                document.removeEventListener('keydown', this.handleVisitingCountriesKeydown);
            },
            watch: {
                billingCountriesFiltered: {
                    handler() {
                        this.billingCountriesFocusedIndex = -1;
                    }
                },
                visitingCountriesFiltered: {
                    handler() {
                        this.visitingCountriesFocusedIndex = -1;
                    }
                },
            },
            computed: {
                selectedBillingCountryName: function() {
                    if( this.selectedBillingCountry === null ) {
                        return 'Välj land';
                    }
                    return this.countries.find(country => country.CountryId === this.selectedBillingCountry)?.CountryName ?? 'Välj land';
                },
                selectedVisitingCountryName: function() {
                    if( this.selectedVisitingCountry === null ) {
                        return 'Välj land';
                    }
                    return this.countries.find(country => country.CountryId === this.selectedVisitingCountry)?.CountryName ?? 'Välj land';
                },
                billingCountriesFiltered: function() {
                    if( this.billingCountriesSearch.trim() == '' ) {
                        return this.countries;
                    } else {
                        return this.countries.filter((item) => {
                            return item.CountryName.toLowerCase().includes(this.billingCountriesSearch.trim().toLowerCase());
                        });
                    }
                },
                visitingCountriesFiltered: function() {
                    if( this.visitingCountriesSearch.trim() == '' ) {
                        return this.countries;
                    } else {
                        return this.countries.filter((item) => {
                            return item.CountryName.toLowerCase().includes(this.visitingCountriesSearch.trim().toLowerCase());
                        });
                    }
                },
                formattedFieldPersonalNumber: {
                    set: function(val) {
                        const number = val.replaceAll('-', '');
                        this.fieldPersonalNumber = number;
                    },
                    get: function() {
                        const number = this.fieldPersonalNumber;

                        if( number.length === 8 ) {
                            return number + '-';
                        }

                        if( number.length > 8 ) {
                            return number.substring(0,8) + '-' + number.substring(8);
                        } else {
                            return number;
                        }

                    },
                },
                formattedIntOrgNumber: {
                    set: function(val) {
                        if( !this.isSwedishOrgNumber && this.checkedCompany === true ) {
                            this.checkedCompany = false;
                            this.clearForm();
                        }

                        this.fieldOrgNumber = val;
                    },
                    get: function() {
                        return this.fieldOrgNumber;
                    }
                },
                formattedFieldOrgNumber: {
                    set: function(val) {
                        if( this.isSwedishOrgNumber && this.checkedCompany ) {
                            this.checkedCompany = false;
                            this.clearForm();
                        }

                        const number = val.replaceAll('-', '');
                        this.fieldOrgNumber = number;
                    },
                    get: function() {
                        const number = this.fieldOrgNumber;

                        if( number.length === 6 ) {
                            return number + '-';
                        }

                        if( number.length > 6 ) {
                            return number.substring(0,6) + '-' + number.substring(6);
                        } else {
                            return number;
                        }

                    },
                },
            },
            methods: {
                toggleBillingCountryDropdown: function() {
                    this.visitingCountriesDropdownOpen = false;
                    this.billingCountriesDropdownOpen = !this.billingCountriesDropdownOpen;
                    this.billingCountriesFocusedIndex = -1;

                    if (this.billingCountriesDropdownOpen) {
                        // Add global event listener when opening
                        document.addEventListener('keydown', this.handleBillingCountriesKeydown);
                        this.$nextTick(() => {
                            this.$refs.billingCountriesSearch.focus();
                        });
                    } else {
                        // Remove listener when closing
                        document.removeEventListener('keydown', this.handleBillingCountriesKeydown);
                    }
                },
                toggleVisitingCountryDropdown: function() {
                    this.billingCountriesDropdownOpen = false;
                    this.visitingCountriesDropdownOpen = !this.visitingCountriesDropdownOpen;
                    this.visitingCountriesFocusedIndex = -1;

                    if (this.visitingCountriesDropdownOpen) {
                        // Add global event listener when opening
                        document.addEventListener('keydown', this.handleVisitingCountriesKeydown);
                        this.$nextTick(() => {
                            this.$refs.visitingCountriesSearch.focus();
                        });
                    } else {
                        // Remove listener when closing
                        document.removeEventListener('keydown', this.handleVisitingCountriesKeydown);
                    }
                },
                handleClickOutside(event) {
                    if (this.$refs.billingCountriesDropdown && !this.$refs.billingCountriesDropdown.contains(event.target)) {
                        this.billingCountriesDropdownOpen = false;
                        this.billingCountriesFocusedIndex = -1;

                        // Remove listener when clicking outside
                        document.removeEventListener('keydown', this.handleBillingCountriesKeydown);
                    }

                    if (this.$refs.visitingCountriesDropdown && !this.$refs.visitingCountriesDropdown.contains(event.target)) {
                        this.visitingCountriesDropdownOpen = false;
                        this.visitingCountriesFocusedIndex = -1;

                        // Remove listener when clicking outside
                        document.removeEventListener('keydown', this.handleVisitingCountriesKeydown);
                    }
                },
                isBillingCountrySelected(option) {
                    const result = this.selectedBillingCountry === option.CountryId;
                    return result;
                },
                isVisitingCountrySelected(option) {
                    const result = this.selectedVisitingCountry === option.CountryId;
                    return result;
                },
                selectBillingCountry: function(county) {
                    this.selectedBillingCountry = county.CountryId;
                    this.billingCountriesDropdownOpen = false;
                    this.billingCountriesSearch = '';
                },
                selectVisitingCountry: function(county) {
                    this.selectedVisitingCountry = county.CountryId;
                    this.visitingCountriesDropdownOpen = false;
                    this.visitingCountriesSearch = '';
                },
                setHasAccount: function(value) {
                    this.hasAccount = value;

                    if( this.hasAccount === false ) {
                        this.fieldFirstName = '';
                        this.fieldLastName = '';
                        this.fieldEmail = '';
                    }
                },
                onlyPersonalNumber($event) {
                    if ($event.target.value.length > 12) {
                        $event.preventDefault();
                        return;
                    }
                    let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                        $event.preventDefault();
                    }
                },
                copyBillingAddress: function () {
                    this.fieldVisitingAddress1 = this.fieldBillingAddress1;
                    this.fieldVisitingAddress2 = this.fieldBillingAddress2;
                    this.fieldVisitingZipCode = this.fieldBillingZipCode;
                    this.fieldVisitingCity = this.fieldBillingCity;
                    this.selectedVisitingCountry = this.selectedBillingCountry;
                },
                checkStep: function (step) {
                    if (this.step >= step) {
                        return true;
                    } else {
                        return false;
                    }
                },
                selectOrgType: function (type) {
                    this.fieldOrgNumber = '';
                    this.orgDropdownOpen = false;
                    this.clearForm();

                    if( type === true ) {
                        this.selectedBillingCountry = 1;
                        this.selectedVisitingCountry = 1;
                    }

                    this.checkedCompany = false;
                    this.step = 1;
                    this.isSwedishOrgNumber = type;
                },
                onlyNumberOrg($event) {
                    if ($event.target.value.length > 10) {
                        $event.preventDefault();
                        return;
                    }
                    let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                        $event.preventDefault();
                    }
                },
                clearForm: function () {
                    this.fieldOrgNumber = '';
                    this.fieldCompanyName = '';
                    this.fieldBillingAddress1 = '';
                    this.fieldBillingAddress2 = '';
                    this.fieldBillingZipCode = '';
                    this.fieldBillingCity = '';
                    this.fieldBillingCountry = '';
                    this.fieldBillingEmail = '';
                    this.fieldVisitingAddress1 = '';
                    this.fieldVisitingAddress2 = '';
                    this.fieldVisitingZipCode = '';
                    this.fieldVisitingCity = '';
                    this.fieldVisitingCountry = '';
                    this.hasAccount = null;
                    this.fieldPersonalNumber = '';
                    this.fieldEmail = '';
                    this.fieldFirstName = '';
                    this.fieldLastName = '';
                    this.step = 1;
                    this.fieldReference = '';
                    this.selectedBillingCountry = null;
                    this.selectedVisitingCountry = null;

                    document.removeEventListener('keydown', this.handleBillingCountriesKeydown);
                    document.removeEventListener('keydown', this.handleVisitingCountriesKeydown);
                },
                checkCompany: function () {
                    if (this.formLoading == true) {
                        return;
                    }
                    this.result = false;
                    this.registeredExisting = null;

                    this.formError = false;
                    this.companyExists = false;

                    const orgNumber = this.fieldOrgNumber.trim();

                    if (this.isSwedishOrgNumber === true) {
                        if (orgNumber === '') {
                            this.formError = { field: 'fieldOrgNumber', message: 'ange ett org. nummer' };
                            return;
                        }

                        if (orgNumber.length !== 10) {
                            this.formError = { field: 'fieldOrgNumber', message: 'ogiltigt org. nummer' };
                            return;
                        }
                    }

                    this.formLoading = true;

                    let query = '?OrganizationNumber=' + orgNumber;

                    this.$http.get(this.restBase + '/softadmin-check-org-number' + query, {
                        headers: { 'X-WP-Nonce': liGlobal.restNonce }
                    }).then((response) => {
                        this.formLoading = false;
                        if (response.data.Exists === false) {
                            this.checkedCompany = true;
                            this.step = 2;
                        } else {
                            this.companyExists = true;
                        }
                    }).catch((error) => {
                        this.formLoading = false;
                        this.formError = { field: '', message: 'Kunde inte kontrollera organisationsnummer. Försök igen.' };
                        console.log( error );
                    });



                },
                authenticateAndRegisterUser: function (device) {
                    const userAgent = navigator.userAgent;

                    const isMobile = userAgent.includes('Mobi') ? 'true' : 'false';
                    const thisDevice = device === 'thisDevice' ? 'true' : 'false';


                    let qrCodeImg = el.querySelector('#qr-code');

                    this.$http.post(this.restBase + '/bankid-federated-login', { isMobile: isMobile, thisDevice: thisDevice }).then((response) => {

                        const autoStartToken = response.data.autoStartToken;
                        const sessionId = response.data.sessionId;

                        if (device === 'thisDevice') {

                            if (userAgent.includes('Mobi')) {
                                if ((userAgent.includes('Mac OS X') && userAgent.includes('Safari/') && !userAgent.includes('Chrome/') && !userAgent.includes('CriOS/')) || (userAgent.includes('Android') && userAgent.includes('Chrome')) || (userAgent.includes('Android') && userAgent.includes('CriOs'))) {
                                    // alert('Is Safari on iPhone or Chrome on Android')
                                    document.location.href = 'https://app.bankid.com/?autostarttoken=' + autoStartToken + '&redirect=null';
                                }
                                else {
                                    // Split scheme so Parcel does not treat bankid:// as a URL pipeline.
                                    document.location.href = ['bankid:', '/', '/', '/?autostarttoken=', autoStartToken, '&redirect=null'].join('');
                                }
                            }
                            else {
                                document.location.href = ['bankid:', '/', '/', '/?autostarttoken=', autoStartToken, '&redirect=null'].join('');
                            }
                        }
                        else {
                            // const qrCode = response.data.QRCode;
                            this.qrCode = response.data.QRCode;

                            // qrCodeImg.src = 'data:image/svg+xml;base64,' + qrCode;
                            // qrCodeImg.parentElement.style.visibility = 'visible';

                        }

                        // Get BankID session
                        // Run a function every second for 165 seconds to check if user is authenticated
                        let i = 0;
                        this.bankIdInterval = setInterval(() => {
                            if (i > 165) {
                                clearInterval(this.bankIdInterval);
                                this.qrCode = null;
                                this.formLoading = false;

                                this.formError = { field: 'fieldBankId', message: 'Autentisering med BankID genomfördes inte. Försök igen.' };
                                return;
                            }
                            this.$http.post(this.restBase + '/get-bankid-session', { sessionId: sessionId }).then((response) => {

                                if( !this.formLoading ) {
                                        return;
                                }

                                if (device === 'otherDevice' && response.data.grandidObject !== undefined && response.data.grandidObject.QRCode) {
                                    this.qrCode = response.data.grandidObject.QRCode;
                                }

                                if (('grandidObject' in response.data) && response.data.grandidObject.message.status == 'failed') {
                                    clearInterval(this.bankIdInterval);
                                    this.qrCode = null;
                                    this.formLoading = false;

                                    this.formError = { field: 'fieldBankId', message: 'Autentisering med BankID genomfördes inte. Försök igen.' };
                                }

                                else if ('userAttributes' in response.data) {
                                    clearInterval(this.bankIdInterval);
                                    this.qrCode = null;

                                    if (this.fieldPersonalNumber !== response.data.userAttributes.personalNumber) {
                                        this.formLoading = false;
                                        this.formError = { field: 'fieldPersonalNumber', message: 'Personnumret stämmer inte överens med BankID-autentiseringen.' };
                                        this.qrCode = null;
                                        return;
                                    }

                                    // Register user in Softadmin after successful authentication
                                    let data = {
                                        "AddressRow1": this.fieldBillingAddress1,
                                        "AddressRow2": this.fieldBillingAddress2,
                                        "City": this.fieldBillingCity,
                                        "CountryId": this.selectedBillingCountry,
                                        "CompanyName": this.fieldCompanyName,
                                        "IsSwedishOrganizationNumber": this.isSwedishOrgNumber ? '1' : '0',
                                        "OrganizationNumber": this.fieldOrgNumber,
                                        "Zipcode": this.fieldBillingZipCode,
                                        "UserEmail": this.fieldEmail,
                                        "UsernameFirst": this.fieldFirstName,
                                        "UsernameLast": this.fieldLastName,
                                        "UserPersonalNumber": this.fieldPersonalNumber,
                                        "AddressRow1Visit": this.fieldVisitingAddress1,
                                        "AddressRow2Visit": this.fieldVisitingAddress2,
                                        "CityVisit": this.fieldVisitingCity,
                                        "CountryIdVisit": this.selectedVisitingCountry,
                                        "ZipcodeVisit": this.fieldVisitingZipCode,
                                        "EmailInvoice": this.fieldBillingEmail,
                                        "YourReference": this.fieldReference,
                                        "SessionId": sessionId
                                    }

                                    console.log(data);

                                    this.$http.post(this.restBase + '/softadmin-register-company', data, {
                                        headers: { 'X-WP-Nonce': liGlobal.restNonce }
                                    }).then((response) => {
                                        this.result = response.data;
                                        this.registeredExisting = this.hasAccount;

                                        if( this.result.ErrorMessage !== undefined && this.result.ErrorMessage === null ) {
                                            this.clearForm();
                                        }

                                    this.formLoading = false;
                                    }).catch((error) => {

                                        this.registerError = true;
                                        this.formError = { field: '', message: 'Kunde inte registrera företaget. Försök igen.' };
                                        this.formLoading = false;
                                        console.log( error );
                                    });
                                }
                                else {

                                    return;
                                }
                            });

                            i++;
                        }, 1000);

                    }).catch((error) => {
                        this.formLoading = false;
                        console.log(error);
                    });
                },
                validateFormAndRegisterUser: async function (device) {
                    if (this.formLoading == true) {
                        return;
                    }

                    this.formError = false;
                    const step = this.step;

                    const regexp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    this.fieldOrgNumber = this.fieldOrgNumber.trim();
                    this.fieldCompanyName = this.fieldCompanyName.trim();
                    this.fieldBillingAddress1 = this.fieldBillingAddress1.trim();
                    this.fieldBillingAddress2 = this.fieldBillingAddress2.trim();
                    this.fieldBillingZipCode = this.fieldBillingZipCode.trim();
                    this.fieldBillingCity = this.fieldBillingCity.trim();
                    this.fieldBillingCountry = this.selectedBillingCountry;
                    this.fieldBillingEmail = this.fieldBillingEmail.trim();
                    this.fieldReference = this.fieldReference.trim();
                    this.fieldVisitingAddress1 = this.fieldVisitingAddress1.trim();
                    this.fieldVisitingAddress2 = this.fieldVisitingAddress2.trim();
                    this.fieldVisitingZipCode = this.fieldVisitingZipCode.trim();
                    this.fieldVisitingCity = this.fieldVisitingCity.trim();
                    this.fieldVisitingCountry = this.selectedVisitingCountry;
                    this.fieldPersonalNumber = this.fieldPersonalNumber.trim();
                    this.fieldFirstName = this.fieldFirstName.trim();
                    this.fieldLastName = this.fieldLastName.trim();
                    this.fieldEmail = this.fieldEmail.trim();




                    if (step >= 2) {

                        if (this.fieldCompanyName === '') {
                            this.formError = { field: 'fieldCompanyName', message: 'ange företagsnamn' };
                            return;
                        }

                        if (this.fieldBillingAddress1 === '') {
                            this.formError = { field: 'fieldBillingAddress1', message: 'ange faktureringsadress' };
                            return;
                        }

                        if (this.fieldBillingZipCode === '') {
                            this.formError = { field: 'fieldBillingZipCode', message: 'ange faktureringspostnummer' };
                            return;
                        }

                        if( this.selectedBillingCountry === 1 ) {
                            const billingZipCode = this.fieldBillingZipCode.replace(/\D/g, '');
                            if( billingZipCode.length !== 5 ) {
                                this.formError = { field: 'fieldBillingZipCode', message: 'ogiltigt faktureringspostnummer' };
                                return;
                            }
                        }

                        if (this.fieldBillingCity === '') {
                            this.formError = { field: 'fieldBillingCity', message: 'ange faktureringsort' };
                            return;
                        }

                        if ( this.selectedBillingCountry === null || this.countries.find(country => country.CountryId === this.selectedBillingCountry) === undefined ) {
                            this.formError = { field: 'fieldBillingCountry', message: 'ange faktureringsland' };
                            return;
                        }

                        if (this.fieldBillingEmail !== '' && !regexp.test(this.fieldBillingEmail)) {
                            this.formError = { field: 'fieldBillingEmail', message: 'ogiltig faktureringsmail' };
                            return;
                        }

                        if (this.fieldReference === '') {
                            this.formError = { field: 'fieldReference', message: 'ange fakturareferens' };
                            return;
                        }

                        this.step = 3;
                    }

                    if (step >= 3) {

                        if (this.fieldVisitingAddress1 === '') {
                            this.formError = { field: 'fieldVisitingAddress1', message: 'ange besöksadress' };
                            return;
                        }

                        if (this.fieldVisitingZipCode === '') {
                            this.formError = { field: 'fieldVisitingZipCode', message: 'ange besökspostnummer' };
                            return;
                        }

                        if( this.selectedVisitingCountry === 1 ) {
                            const visitingZipCode = this.fieldVisitingZipCode.replace(/\D/g, '');
                            if( visitingZipCode.length !== 5 ) {
                                this.formError = { field: 'fieldVisitingZipCode', message: 'ogiltigt besökspostnummer' };
                                return;
                            }
                        }

                        if (this.fieldVisitingCity === '') {
                            this.formError = { field: 'fieldVisitingCity', message: 'ange besökssort' };
                            return;
                        }

                        if ( this.selectedVisitingCountry === null || this.countries.find(country => country.CountryId === this.selectedVisitingCountry) === undefined ) {
                            this.formError = { field: 'fieldVisitingCountry', message: 'ange besöksland' };
                            return;
                        }
                        this.step = 4;
                    }

                    if (step >= 4) {
                        if (this.hasAccount === null) {
                            this.formError = { field: 'fieldHasAccount', message: 'välj om du har ett konto' };
                            return;
                        }

                        if (this.hasAccount === true) {
                            if (this.fieldPersonalNumber === '') {
                                this.formError = { field: 'fieldPersonalNumber', message: 'ange ett personnummer' };
                                return;
                            }

                            if (this.fieldPersonalNumber.length !== 12) {
                                this.formError = { field: 'fieldPersonalNumber', message: 'oglitigt personnummer, 12 siffror krävs.' };
                                return;
                            }

                            if (!Personnummer.valid(this.fieldPersonalNumber)) {
                                this.formError = { field: 'fieldPersonalNumber', message: 'oglitigt personnummer' };
                                return;
                            }
                        } else if (this.hasAccount === false) {
                            if (this.fieldPersonalNumber === '') {
                                this.formError = { field: 'fieldPersonalNumber', message: 'ange ett personnummer' };
                                return;
                            }
                            if (this.fieldFirstName === '') {
                                this.formError = { field: 'fieldFirstName', message: 'ange förnamn för administratör' };
                                return;
                            }

                            if (this.fieldLastName === '') {
                                this.formError = { field: 'fieldLastName', message: 'ange efternamn för administratör' };
                                return;
                            }

                            if (this.fieldEmail === '') {
                                this.formError = { field: 'fieldEmail', message: 'ange en e-postadress administratör' };
                                return;
                            }

                            if (!regexp.test(this.fieldEmail)) {
                                this.formError = { field: 'fieldEmail', message: 'ogiltig e-postadress' };
                                return;
                            }

                        }

                        this.result = false;
                        this.formLoading = true;

                        if (this.hasAccount === true) {
                            let query = '?PersonalNumber=' + this.fieldPersonalNumber;

                            let response;

                            try {
                                response = await this.$http.get(this.restBase + '/softadmin-check-personal-number' + query, {
                                    headers: { 'X-WP-Nonce': liGlobal.restNonce }
                                });
                            } catch (error) {
                                this.formLoading = false;
                                this.formError = { field: '', message: 'Kunde inte kontrollera personnummer. Försök igen.' };
                                console.log( error );
                                return;
                            }

                            if (response.data.Exists === false) {
                                this.formLoading = false;
                                this.formError = { field: 'fieldPersonalNumber', message: 'konto finns inte med angivet personnummer' };
                                return;
                            }

                            // let data = {
                            //     "AddressRow1": this.fieldBillingAddress1,
                            //     "AddressRow2": this.fieldBillingAddress2,
                            //     "City": this.fieldBillingCity,
                            //     "Country": this.fieldBillingCountry,
                            //     "CompanyName": this.fieldCompanyName,
                            //     "IsSwedishOrganizationNumber": this.isSwedishOrgNumber ? '1' : '0',
                            //     "OrganizationNumber": this.fieldOrgNumber,
                            //     "Zipcode": this.fieldBillingZipCode,
                            //     "UserEmail": this.fieldEmail,
                            //     "UsernameFirst": this.fieldFirstName,
                            //     "UsernameLast": this.fieldLastName,
                            //     "UserPersonalNumber": this.fieldPersonalNumber,
                            //     "AddressRow1Visit": this.fieldVisitingAddress1,
                            //     "AddressRow2Visit": this.fieldVisitingAddress2,
                            //     "CityVisit": this.fieldVisitingCity,
                            //     "CountryVisit": this.fieldVisitingCountry,
                            //     "ZipcodeVisit": this.fieldVisitingZipCode,
                            //     "EmailInvoice": this.fieldBillingEmail,
                            //     "YourReference": this.fieldReference
                            // }

                            // console.log(data);

                            // // console.log('Här anropas Softadmin');
                            // this.$http.post(this.restBase + '/softadmin-register-company', data).then((response) => {
                            //     console.log( response.data );
                            //     this.result = response.data;
                            //     this.formLoading = false;
                            //     this.registeredExisting = true;

                            //     if( this.result.ErrorMessage !== undefined && this.result.ErrorMessage === null ) {
                            //         this.clearForm();
                            //     }
                            // }).catch((error) => {
                            //     console.log( error );

                            //     this.registerError = true;
                            //     this.formLoading = false;
                            // });
                        }

                        this.authenticateAndRegisterUser(device);
                    }

                },
                cancelBankId: function() {
                    clearInterval(this.bankIdInterval);
                    this.qrCode = null;
                    this.formLoading = false;
                },
            }
        })

        app.config.globalProperties.$http = axios
        app.config.globalProperties.axios = axios
        app.mount(el)
    })
})
